import React from 'react';
/**
 * Permet d'inhiber un comportement par défault
 * L'idée est que l'on passe une fonction au hook, cette fonction déclenche une action
 * On récupère alors deux fonctions :
 *      - La première permet de récupérer la fonction qui déclenche l'action
 *      - La deuxième permet de déclencher l'action si la première n'a pas été appelée,
 *        sinon elle ne fait rien
 *
 * Par exemple, imaginons une fonction (action) qui permette
 * de passer de l'état affiché à caché (et vice versa) d'une partie d'un composant
 * Par défault votre composant fait que si on clique dessus l'action est déclenché
 * Mais vous souhaiteriez donner la possibilité à l'utilisateur de votre composant
 * (qui passe un sous composant via les children) de pouvoir décider à quel endroit le click se fait
 * En utilisant ce hook, le click sur votre composant doit déclencher la deuxième fonction
 * Et vous passer au children la première fonction (via un cloneElement par exemple)
 * Si l'utilisateur de votre composant n'utilise pas la 1ère fonction,
 * alors lorsque l'on cliquera sur votre composant, l'action se déclenchera
 * Si au contraire, l'utilisateur de votre composant utilise la fonction passé en props
 * (donc la première fonction),il va récupérer la fonction permettant de déclencher l'action
 * La fonction que votre composant utilise,
 * va être inhiber et donc lors du click sur votre composant, plus rien ne se passera.
 * Libre alors à l'utilisateur de votre composant de choisir comment l'action sera déclenché!!!!
 */
var useCallDetectorInhibitor = function useCallDetectorInhibitor(handler) {
  var context = React.useMemo(function () {
    return {};
  }, [handler]);
  context.isCall = false;
  var caller = React.useCallback(function () {
    context.isCall = true;
    return handler;
  }, [handler]);
  var controlledHandler = React.useCallback(function () {
    if (context.isCall) {
      return null;
    }
    return handler.apply(void 0, arguments);
  }, [handler]);
  return [caller, controlledHandler];
};
export default useCallDetectorInhibitor;